import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { withPlanDate } from "../PlanDateContext";
const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    marginRight: 16,
    color: theme.HeaderSelectedText,
    fontSize: 14,
    fontWeight: 600,
    "& span:last-child": {
      marginLeft: 16,
    },
  },
});
class PlanDateHeader extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { classes, planDate, startDate } = this.props;
    return (
      <div className={classes.container}>
        <span>Plan Date: {startDate ? `${startDate} - ` : ""} {planDate ?? this.props.userData.userProfile.planDate}</span>
        <span>Terminal: {this.props.userData.userProfile.terminal.code}</span>
      </div>
    );
  }
}

export default compose(
  withPlanDate,
  withUserProfile,
  withStyles(styles)
)(PlanDateHeader);
